export const ProductStatus = {
  ACTIVE: 'Active',
};

export const ProductRoute = {
  PRODUCTS: 'products',
};

export const ProductPathName = {
  PRODUCTS: 'products',
};
